// 页面路径：store/index.js
import {createStore} from 'vuex'


const loadState = () => {
    try {
      const serializedState = localStorage.getItem('state');
      if (serializedState === null) return undefined;
      return JSON.parse(serializedState);
    } catch (err) {
      return undefined;
    }
};
  
  const saveState = (state) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem('state', serializedState);
    } catch (err) {
      // 忽略错误
    }
};


const store = createStore({
    state: loadState() || {
        user_info: {
            prov_id: 0,
            exam_class: 0,
        }, // 用户信息
        pro_list: {
            bkdata: [],
            zkdata: []
        },
        ai_pro_list: [], // 保存AI智能填报专业优先筛选信息
        ai_school_id: { id: 0, school: "" }, // AI智能填报筛选院校ID
        merchant_info: [], // 商户信息
        school_compare_list: [], // 院校对比列表
        prov_list:[],  // 省份列表
        language_list:[], // 语言列表
        pending_vip_gaokao_edit: false, // VIP升级后待打开成绩表单
    },
    getters: {
        isLogin: (state) => {
            return !!state.user_info.access_token; // 依赖于 Vuex store 的 state
        },
        isLock_prov: (state) => {//获取是否上锁
            if (!isEmpty(state.user_info) && !isEmpty(state.user_info.is_super)) {
                return false
            }
            if (state.user_info.vip_upgrade_edit_available) {
                return false
            }
            return isEmpty(state.user_info) ? false : !isEmpty(state.user_info.prov_id)
        }, isLock_exam: (state) => {//获取是否上锁

            if (!isEmpty(state.user_info) && !isEmpty(state.user_info.is_super)) {
                return false
            }
            if (state.user_info.vip_upgrade_edit_available) {
                return false
            }
            return isEmpty(state.user_info) ? false : !isEmpty(state.user_info.exam_class)

        },
        
        get_user_info:(state)=>{
            return state.user_info;
        },
        getSourceMerchant: (state) => {
            return state.merchant_info;
        }

    },
    mutations: {
        setUserInfo(state, user_msg) {
            state.user_info = user_msg;
            saveState(state); // 保存状态到 localStorage
        },
        userLogout(state) {
            state.user_info = {
                prov_id: 0,
                exam_class: 0,
            };
            state.prov_list = [];
            state.language_list = [];
            saveState(state); // 保存状态到 localStorage
        },
        basicData(state,data){
            const { list, type } = data;
            if(type === 1){
                state.prov_list = list;
            }else if(type === 2){
                state.language_list = list;
            }
            saveState(state); // 保存状态到 localStorage
        },
        // 添加设置商户信息
        setMerchantInfo(state, merchantInfo) {
            state.merchant_info = merchantInfo || [];
            saveState(state);
        },
        setPendingVipGaoKaoEdit(state, value) {
            state.pending_vip_gaokao_edit = !!value;
            saveState(state);
        }

    },
    strict: true//严格模式,发布环境不要启用,避免性能损失

})

function isEmpty(value) {//判断值是否为空
    return (
        value == null || // 检查 null 和 undefined
        Object.is(value, NaN) || // 检查 NaN
        value === '' || // 检查空字符串
        value === 0 || // 检查 0
        (typeof value === 'object' && Object.keys(value).length === 0) || // 检查空对象
        (Array.isArray(value) && value.length === 0) // 检查空数组
      );
}
export { isEmpty }; // 导出 isEmpty 函数
export default store
